import RequestSidebar from "@components/RequestSidebar/RequestSidebar";
import { t } from "@utils/i18n";
import { RefObject } from "react";

interface Props {
  backgroundRef: RefObject<HTMLElement>;
  lookingForRef: RefObject<HTMLElement>;
  benefitsRef: RefObject<HTMLElement>;
  whoWeAreRef: RefObject<HTMLElement>;
  qaRef: RefObject<HTMLElement>;
  blockedKeys?: Section[];
  onSignupClick?: () => void;
  isConfidential?: boolean;
  topOffset?: number;
  /** Whether there is any benefits content to show */
  hasBenefits?: boolean;
  /** Whether Q&A/discussion is enabled for this request */
  isDiscussionEnabled?: boolean;
}

export enum Section {
  BACKGROUND = "background",
  LOOKING_FOR = "looking-for",
  BENEFITS = "benefits",
  WHO_WE_ARE = "who-we-are",
  QA = "qa",
}

export default function Sidebar({
  backgroundRef,
  lookingForRef,
  benefitsRef,
  whoWeAreRef,
  qaRef,
  blockedKeys = [],
  onSignupClick,
  isConfidential = false,
  topOffset = 20,
  hasBenefits = true,
  isDiscussionEnabled = true,
}: Props) {
  const items = [
    { key: Section.BACKGROUND, ref: backgroundRef, title: t("pages.rfp_page.headings.background") },
    {
      key: Section.LOOKING_FOR,
      ref: lookingForRef,
      title: t("pages.rfp_page.headings.looking_for"),
    },
    ...(hasBenefits
      ? ([
          { key: Section.BENEFITS, ref: benefitsRef, title: t("pages.rfp_page.headings.offer") },
        ] as const)
      : ([] as const)),
    ...(!isConfidential
      ? ([
          {
            key: Section.WHO_WE_ARE,
            ref: whoWeAreRef,
            title: t("pages.rfp_page.headings.who_we_are"),
          },
        ] as const)
      : ([] as const)),
    ...(isDiscussionEnabled
      ? ([{ key: Section.QA, ref: qaRef, title: t("pages.rfp_page.headings.q_a") }] as const)
      : ([] as const)),
  ];

  return (
    <RequestSidebar
      items={items}
      blockedKeys={blockedKeys}
      onSignupClick={onSignupClick}
      topOffset={topOffset}
    />
  );
}
